/**
 * Validation utilities for onboarding wizard
 */

import i18n from 'i18n';

/**
 * Validate Step 1 fields (Company Information)
 * @param {Object} formData - Form data object
 * @returns {Object} Validation errors object
 */
export const validateStep1 = (formData) => {
  const errors = {};

  if (!formData.organizationName || formData.organizationName.trim().length < 2) {
    errors.organizationName = i18n.t(
      'onboarding:validation.orgNameMin',
      'Organization name must be at least 2 characters',
    );
  }

  if (formData.organizationName && formData.organizationName.length > 100) {
    errors.organizationName = i18n.t(
      'onboarding:validation.orgNameMax',
      'Organization name must not exceed 100 characters',
    );
  }

  return errors;
};

/**
 * Validate Step 3 fields (Team & Background)
 * Checks conditional "Other" fields
 * @param {Object} formData - Form data object
 * @returns {Object} Validation errors object
 */
export const validateStep3 = (formData) => {
  const errors = {};

  // If user selected "Other" for job role, they must provide the custom role
  if (formData.userJobRole === 'Other' && !formData.otherJobRole?.trim()) {
    errors.otherJobRole = i18n.t('onboarding:wizard.specifyRole', 'Please specify your role');
  }

  // "Tell us more" (otherHearAboutUs) is intentionally optional, even when
  // hearAboutUs === 'Other', so no validation is applied here.

  return errors;
};
